export default "__VITE_ASSET__NDPIG0Ev__"